export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      locations: 'Locations',
      contact: 'Contact',
      quote: 'Get Quote',
      tools: 'Tools',
      registerLocker: 'Register Locker',
      loginLocker: 'Locker Login',
      tracking: 'Track Shipment',
      registerTracking: 'Register Tracking',
      sessionMatriz: 'Session Matriz'
    },
    hero: {
      tagline: 'Your Global Logistics Partner',
      subtitle: 'Over 20 years delivering excellence in freight forwarding, customs brokerage, and door-to-door shipping services worldwide.',
      cta: 'Request Quote',
      secondary: 'Our Services'
    },
    about: {
      title: 'WHO WE ARE',
      subtitle: 'GREYMAR INTERNATIONAL FREIGHT LLC',
      description: 'We are a reference in shipping to Venezuela. With over 20 years of proven experience, we provide guaranteed satisfaction and premium service. Our professional logistics teams and equipment ensure the best handling of your merchandise.',
      mission: 'Our Mission',
      missionText: 'To offer quality and responsible service, based on the trust and loyalty of our customers. We bring happiness and peace of mind to hundreds of Venezuelan homes, sent by their relatives residing abroad.',
      stats: {
        years: 'Years Experience',
        countries: 'Countries Served',
        shipments: 'Annual Shipments',
        clients: 'Happy Clients'
      }
    },
    services: {
      title: 'OUR LOGISTICS SERVICES',
      subtitle: 'Comprehensive solutions for all your freight needs',
      items: {
        ground: {
          title: 'Ground Transportation',
          subtitle: 'USA & Venezuela',
          description: 'We guarantee the safety and total control of your cargo. We own and operate our own fleet of trucks in both the United States and Venezuela, ensuring reliable pickup and door-to-door delivery.'
        },
        international: {
          title: 'International Logistics',
          subtitle: 'Global Reach',
          description: 'Our operation goes far beyond the United States. We are part of Maurice Ward Group, a leading European logistics company with presence in 28 countries, plus our own logistics operation in Asia.'
        },
        warehousing: {
          title: 'Strategic Warehousing',
          subtitle: 'Miami - Venezuela',
          description: 'Optimize your supply chain with our dual storage solutions. We have our own warehouses strategically located in Miami (USA) and Venezuela, equipped to receive and dispatch all types of goods.'
        },
        consolidation: {
          title: 'Cargo Consolidation',
          subtitle: 'Air & Sea',
          description: 'We offer flexible consolidation and deconsolidation services for all types of cargo, both air and sea, from anywhere in the world. We maximize space and reduce your operating costs.'
        },
        nvocc: {
          title: 'NVOCC Operator',
          subtitle: 'Direct Ocean Freight',
          description: 'We act as a non-vessel operating common carrier (NVOCC). We have the license to charter containers dealing directly with major shipping lines worldwide, offering more competitive rates.'
        },
        tsa: {
          title: 'TSA Direct Operation',
          subtitle: 'Air Cargo',
          description: 'We are TSA (Transportation Security Administration) certified. This license allows us to operate directly with major cargo airlines without intermediaries, providing greater security and speed.'
        },
        customs: {
          title: 'Customs Brokerage',
          subtitle: 'Venezuela',
          description: 'We facilitate the entry of your merchandise into Venezuela. We maintain active customs brokerage operations at La Guaira, Puerto Cabello, and Maiquetía Airport.'
        },
        bonded: {
          title: 'Bonded Warehouses',
          subtitle: 'USA',
          description: 'We offer Bonded CFS & Bonded Warehouse service in the United States. Store your cargo under customs control without paying import taxes until nationalization, improving your cash flow.'
        },
        ipostel: {
          title: 'IPOSTEL Certified',
          subtitle: 'Courier Services',
          description: 'We hold the official postal authorization from IPOSTEL Venezuela. This certifies us to deliver packages as an International Courier, guaranteeing formal, secure service at the best market prices.'
        }
      }
    },
    why: {
      title: 'WHY CHOOSE GREYMAR',
      items: {
        experience: {
          title: '20+ Years Experience',
          description: 'Proven track record in international logistics'
        },
        fleet: {
          title: 'Own Fleet',
          description: 'Direct control of ground transportation in USA & Venezuela'
        },
        global: {
          title: 'Global Network',
          description: 'Part of Maurice Ward Group with presence in 28 countries'
        },
        certified: {
          title: 'Fully Certified',
          description: 'TSA, NVOCC, IPOSTEL licensed operator'
        }
      }
    },
    locations: {
      title: 'OUR LOCATIONS',
      subtitle: 'Strategic presence in key logistics hubs',
      miami: {
        title: 'Miami Headquarters',
        address: '7703 NW 46th St, Doral, FL 33166',
        phone: '+1 (786) 655-0745'
      },
      orlando: {
        title: 'Orlando Office',
        address: '2148 Orinoco Dr, Orlando, FL 32837, Suite 348',
        phone: '+1 (321) 419-5100'
      }
    },
    team: {
      title: 'OUR TEAM',
      subtitle: 'Meet the professionals behind Greymar Logistics',
      miami: 'Miami Team',
      venezuela: 'Venezuela Team',
      placeholder: 'Photo coming soon'
    },
    contact: {
      title: 'GET IN TOUCH',
      subtitle: 'Request a quote or contact us for any inquiries',
      form: {
        name: 'Full Name',
        email: 'Email Address',
        phone: 'Phone Number',
        company: 'Company Name',
        service: 'Service Required',
        selectService: 'Select a service',
        message: 'Message',
        messagePlaceholder: 'Tell us about your shipping needs...',
        submit: 'Send Message',
        sending: 'Sending...'
      },
      info: {
        title: 'Contact Information',
        email: 'info@greymarlogistics.com',
        hours: 'Monday - Friday: 9AM - 6PM EST'
      }
    },
    footer: {
      description: 'Your trusted partner for international freight forwarding and logistics solutions since 2004.',
      quickLinks: 'Quick Links',
      services: 'Services',
      contact: 'Contact',
      rights: 'All rights reserved.'
    }
  },
  es: {
    nav: {
      home: 'Inicio',
      about: 'Nosotros',
      services: 'Servicios',
      locations: 'Ubicaciones',
      contact: 'Contacto',
      quote: 'Cotizar',
      tools: 'Herramientas',
      registerLocker: 'Registrar Casillero',
      loginLocker: 'Iniciar Sesión',
      tracking: 'Rastrear Envío',
      registerTracking: 'Registrar Tracking',
      sessionMatriz: 'Sesión Matriz'
    },
    hero: {
      tagline: 'Tu Socio Logístico Global',
      subtitle: 'Más de 20 años entregando excelencia en transporte de carga, agenciamiento aduanal y servicios de envío puerta a puerta en todo el mundo.',
      cta: 'Solicitar Cotización',
      secondary: 'Nuestros Servicios'
    },
    about: {
      title: 'QUIÉNES SOMOS',
      subtitle: 'GREYMAR INTERNATIONAL FREIGHT LLC',
      description: 'Somos referencia en cargas Venezuela. Con más de 20 años comprobables de experiencia, Brindamos satisfacción garantizada y servicios de calidad. Nuestro equipo de logística profesional asegura el mejor manejo de todos sus mercancías',
      mission: 'Nuestra Misión',
      missionText: 'Ofrecer un servicio de calidad y responsabilidad, basado en la confianza y lealtad de nuestros clientes. Llevamos felicidad y tranquilidad a cientos de hogares venezolanos, enviada por sus familiares residentes en el extranjero.',
      stats: {
        years: 'Años de Experiencia',
        countries: 'Países Atendidos',
        shipments: 'Envíos Anuales',
        clients: 'Clientes Satisfechos'
      }
    },
    services: {
      title: 'NUESTROS SERVICIOS LOGÍSTICOS',
      subtitle: 'Soluciones integrales para todas sus necesidades de carga',
      items: {
        ground: {
          title: 'Transporte Terrestre',
          subtitle: 'USA y Venezuela',
          description: 'Garantizamos la seguridad y el control total de su carga. Poseemos y operamos nuestra propia flota de camiones tanto en Estados Unidos como en Venezuela, asegurando recolección y entrega puerta a puerta confiables.'
        },
        international: {
          title: 'Logística Internacional',
          subtitle: 'Alcance Global',
          description: 'Nuestra operación va mucho más allá de Estados Unidos. Formamos parte de Maurice Ward Group, empresa líder en logística europea con presencia en 28 países, más nuestra propia operación logística en Asia.'
        },
        warehousing: {
          title: 'Almacenamiento Estratégico',
          subtitle: 'Miami - Venezuela',
          description: 'Optimice su cadena de suministro con nuestras soluciones de almacenamiento dual. Contamos con almacenes ubicados estratégicamente en Miami (USA) y en Venezuela, equipados para todo tipo de mercancías.'
        },
        consolidation: {
          title: 'Consolidación de Carga',
          subtitle: 'Aéreo y Marítimo',
          description: 'Ofrecemos servicios flexibles de consolidación y desconsolidación para todo tipo de cargas, tanto aéreas como marítimas, desde cualquier origen. Maximizamos espacio y reducimos sus costos operativos.'
        },
        nvocc: {
          title: 'Operador NVOCC',
          subtitle: 'Transporte Marítimo Directo',
          description: 'Actuamos como operador de transporte marítimo sin buque propio (NVOCC). Poseemos licencia para fletar contenedores tratando directamente con las principales líneas navieras, ofreciendo tarifas más competitivas.'
        },
        tsa: {
          title: 'Operación Directa TSA',
          subtitle: 'Carga Aérea',
          description: 'Poseemos certificación TSA (Transportation Security Administration). Esta licencia nos permite operar directamente con las principales aerolíneas cargueras sin intermediarios, mayor seguridad y rapidez.'
        },
        customs: {
          title: 'Agenciamiento Aduanal',
          subtitle: 'Venezuela',
          description: 'Facilitamos el ingreso de su mercancía a Venezuela. Mantenemos operaciones activas de agenciamiento aduanal en La Guaira, Puerto Cabello y Aeropuerto de Maiquetía.'
        },
        bonded: {
          title: 'Almacenes Bonded',
          subtitle: 'USA',
          description: 'Ofrecemos servicio de Bonded CFS & Bonded Warehouse en Estados Unidos. Almacene su carga bajo control aduanero sin pagar impuestos de importación hasta la nacionalización, mejorando su flujo de caja.'
        },
        ipostel: {
          title: 'Certificación IPOSTEL',
          subtitle: 'Servicio Courier',
          description: 'Contamos con la concesión oficial de habilitación postal de IPOSTEL Venezuela. Esta certificación nos avala para entrega de paquetería como Courier Internacional con los mejores precios del mercado.'
        }
      }
    },
    why: {
      title: 'POR QUÉ ELEGIR GREYMAR',
      items: {
        experience: {
          title: '+20 Años de Experiencia',
          description: 'Trayectoria comprobada en logística internacional'
        },
        fleet: {
          title: 'Flota Propia',
          description: 'Control directo del transporte terrestre en USA y Venezuela'
        },
        global: {
          title: 'Red Global',
          description: 'Parte de Maurice Ward Group con presencia en 28 países'
        },
        certified: {
          title: 'Certificados',
          description: 'Operador con licencias TSA, NVOCC, IPOSTEL'
        }
      }
    },
    locations: {
      title: 'NUESTRAS UBICACIONES',
      subtitle: 'Presencia estratégica en centros logísticos clave',
      miami: {
        title: 'Sede Miami',
        address: '7703 NW 46th St, Doral, FL 33166',
        phone: '+1 (786) 655-0745'
      },
      orlando: {
        title: 'Oficina Orlando',
        address: '2148 Orinoco Dr, Orlando, FL 32837, Suite 348',
        phone: '+1 (321) 419-5100'
      }
    },
    team: {
      title: 'NUESTRO EQUIPO',
      subtitle: 'Conoce a los profesionales detrás de Greymar Logistics',
      miami: 'Equipo Miami',
      venezuela: 'Equipo Venezuela',
      placeholder: 'Foto próximamente'
    },
    contact: {
      title: 'CONTÁCTANOS',
      subtitle: 'Solicita una cotización o contáctanos para cualquier consulta',
      form: {
        name: 'Nombre Completo',
        email: 'Correo Electrónico',
        phone: 'Teléfono',
        company: 'Nombre de Empresa',
        service: 'Servicio Requerido',
        selectService: 'Seleccionar servicio',
        message: 'Mensaje',
        messagePlaceholder: 'Cuéntanos sobre tus necesidades de envío...',
        submit: 'Enviar Mensaje',
        sending: 'Enviando...'
      },
      info: {
        title: 'Información de Contacto',
        email: 'info@greymarlogistics.com',
        hours: 'Lunes - Viernes: 9AM - 6PM EST'
      }
    },
    footer: {
      description: 'Tu socio de confianza para soluciones de transporte internacional y logística desde 2004.',
      quickLinks: 'Enlaces Rápidos',
      services: 'Servicios',
      contact: 'Contacto',
      rights: 'Todos los derechos reservados.'
    }
  }
};
